import $i18n from 'panda-i18n'; // 基础数据

const WORK_TYPE = [
  {
    label: $i18n.get({ id: 'CheckIn.four_px', dm: '入库' }),
    value: '10',
  },

  {
    label: $i18n.get({ id: 'Transit.four_px', dm: '移库' }),
    value: '12',
  },

  {
    label: $i18n.get({ id: 'Replenishment.four_px', dm: '补货' }),
    value: '20',
  },

  {
    label: $i18n.get({ id: 'Return.four_px', dm: '退货' }),
    value: '30',
  },

  {
    label: $i18n.get({ id: 'DB.Packaging.four_px', dm: '打包' }),
    value: 'pack',
  },

  {
    label: $i18n.get({ id: 'JH.Picking.four_px', dm: '拣货' }),
    value: 'pick',
  },
];

// 容器类型
const CONTAINER_TYPE = [
  {
    label: $i18n.get({ id: 'BigBaskets.four_px', dm: '大筐' }),
    value: 'BSL',
  },

  {
    label: $i18n.get({ id: 'MiddleBasket.four_px', dm: '中筐' }),
    value: 'BSM',
  },

  {
    label: $i18n.get({ id: 'SmallBasket.four_px', dm: '小筐' }),
    value: 'BSS',
  },

  {
    label: $i18n.get({ id: 'Trolley.four_px', dm: '手推车' }),
    value: 'ST',
  },

  {
    label: $i18n.get({ id: 'LongChe.four_px', dm: '笼车' }),
    value: 'BMC',
  },

  {
    label: $i18n.get({ id: 'TraySubStandard.four_px', dm: '托盘-亚标' }),
    value: 'PAS',
  },

  {
    label: $i18n.get({ id: 'TrayEuropeanStandard.four_px', dm: '托盘-欧标' }),
    value: 'PEU',
  },

  {
    label: $i18n.get({ id: 'TrayAmericanStandard.four_px', dm: '托盘-美标' }),
    value: 'PUS',
  },

  {
    label: $i18n.get({ id: 'JianHuoChe.four_px', dm: '拣货车' }),
    value: 'PK',
  },

  {
    label: $i18n.get({ id: 'SortingWallContainer.four_px', dm: '分拣墙容器' }),
    value: 'ASSORT_WALL',
  },
];

// 工作状态
const WORK_STATUS = [
  {
    label: $i18n.get({ id: 'TakeUp.four_px', dm: '占用' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'XZ.Idle.four_px', dm: '闲置' }),
    value: 'Y',
  },
];

// 启用状态
const ENABLE_STATUS = [
  {
    label: $i18n.get({ id: 'Enable.four_px', dm: '启用' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'JY.Disable.four_px', dm: '禁用' }),
    value: 'N',
  },
];

// 客户组关系
const CUSTOME_GROUP_RELATION = [
  {
    label: $i18n.get({ id: 'Contains', dm: '包含' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'DoesNotContain', dm: '不包含' }),
    value: 'N',
  },
];

// 是否提交总单
const SUBMIT_STATUS = [
  {
    label: $i18n.get({ id: 'DeliverySubmissionList', dm: '发货提交总单' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'ShippingSubmissionTotal', dm: '发运提交总单' }),
    value: 'D',
  },

  {
    label: $i18n.get({ id: 'F.No.four_px', dm: '否' }),
    value: 'N',
  },
];

// 用途
const TYPE = [
  {
    label: $i18n.get({ id: 'CheckIn.four_px', dm: '入库' }),
    value: 'I',
  },

  {
    label: $i18n.get({ id: 'CheckedOut.four_px', dm: '出库' }),
    value: 'O',
  },
];

// 用途 - 入库disabled
const NO_IN_TYPE = [
  {
    label: $i18n.get({ id: 'CheckIn.four_px', dm: '入库' }),
    value: 'I',
    // disabled: true,
  },

  {
    label: $i18n.get({ id: 'CheckedOut.four_px', dm: '出库' }),
    value: 'O',
  },
];

// 分拣状态
const ASSORT_STATUS = [
  {
    label: $i18n.get({ id: 'Idle.four_px', dm: '空闲' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'Distributing.four_px', dm: '分拣中' }),
    value: 'N',
  },
];

// 操作台类型
const OPERATE_FLOOR_TYPE = [
  {
    label: $i18n.get({ id: 'Sorting.four_px', dm: '分拣' }),
    value: 'D',
  },

  {
    label: $i18n.get({ id: 'DB.Packaging.four_px', dm: '打包' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Package', dm: '集包' }),
    value: 'G',
  },
];

// 库区
const AREA_TYPE = [
  {
    label: 'A',
    value: 'A',
  },

  {
    label: 'B',
    value: 'B',
  },

  {
    label: 'C',
    value: 'C',
  },

  {
    label: 'D',
    value: 'D',
  },
];

// 包装类型
const PACKING_TYPE = [
  {
    label: 'bag',
    value: 'bag',
  },

  {
    label: 'box',
    value: 'box',
  },

  {
    label: 'strap',
    value: 'strap',
  },
  {
    label: 'bubble bag',
    value: 'bubbleBag',
  },
  {
    label: 'Envelope bag',
    value: 'envelopeBag',
  },
  {
    label: 'Filling material',
    value: 'fillingMaterial',
  },
  {
    label: 'Encapsulant',
    value: 'encapsulant',
  },
  {
    label: 'label',
    value: 'label',
  },
  {
    label: 'pallet',
    value: 'pallet',
  },
];

// 包材类型2
const PACKAGE_TYPE2 = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: 'bag',
    value: 'bag',
  },

  {
    label: 'box',
    value: 'box',
  },

  {
    label: 'strap',
    value: 'strap',
  },
];

// 业务类型
const BUSINESS_TYPE = [
  {
    label: 'AE4PL',
    value: 'AE4PL2',
  },

  {
    label: 'MF4PL',
    value: 'MF4PL',
  },
  {
    label: $i18n.get({ id: 'CustomerDesignation', dm: '客户指定' }),
    value: 'fixedCustomer',
  },

  {
    label: $i18n.get({ id: 'TERM.All_8xooM', dm: '通用' }),
    value: 'other',
  },
];

// 业务类型2
const BUSINESS_TYPE2 = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: 'AE4PL',
    value: 'AE4PL2',
  },

  {
    label: 'MF4PL',
    value: 'MF4PL',
  },

  {
    label: $i18n.get({ id: 'CustomerDesignation', dm: '客户指定' }),
    value: 'fixedCustomer',
  },

  {
    label: $i18n.get({ id: 'QT.Other.four_px', dm: '其他' }),
    value: 'other',
  },
];

// 包装材质
const PACKING_TEXTURE = [
  {
    label: $i18n.get({ id: 'Wood.four_px', dm: '木头' }),
    value: 'Wood',
  },

  {
    label: $i18n.get({ id: 'Paper.four_px', dm: '纸质' }),
    value: 'Paper',
  },

  {
    label: $i18n.get({ id: 'Plastic.four_px', dm: '塑料' }),
    value: 'Plastic',
  },

  {
    label: $i18n.get({ id: 'Metal.four_px', dm: '金属' }),
    value: 'Metal',
  },

  {
    label: $i18n.get({ id: 'QT.Other.four_px', dm: '其他' }),
    value: 'Other',
  },
];

// 核销模式
const DESTORY_TYPE = [
  {
    label: $i18n.get({ id: 'MeasurementUsingWriteoff', dm: '计量（使用核销）' }),
    value: 'use1',
  },

  {
    label: $i18n.get({ id: 'NonmeasurementCollectingAndWriti_1048085899', dm: '非计量（领用核销）' }),
    value: 'use2',
  },
];

const CustomerCodeOrCustomerId = [
  {
    label: $i18n.get({ id: 'customer_code', dm: '客户编码' }),
    value: 'customerCode',
  },

  {
    label: $i18n.get({ id: 'CustomerMnemonicCode', dm: '客户助记码' }),
    value: 'customerId',
  },
];

// 包装价格
const PACKING_PRICE = [
  {
    label: 'HKD',
    value: 'HKD',
  },
  {
    label: 'CNY',
    value: 'CNY',
  },
  {
    label: 'USD',
    value: 'USD',
  },
  {
    label: 'GBP',
    value: 'GBP',
  },

  {
    label: 'AUD',
    value: 'AUD',
  },
  {
    label: 'EUR',
    value: 'EUR',
  },
  {
    label: 'CAD',
    value: 'CAD',
  },
  {
    label: 'OPY',
    value: 'OPY',
  },
  {
    label: 'CZK',
    value: 'CZK',
  },
  {
    label: 'MYR',
    value: 'MYR',
  },
  {
    label: 'SGD',
    value: 'SGD',
  },
];

// 包材盘点状态
const PACKAGE_TAKESTOCK_STATUS = [
  {
    label: $i18n.get({ id: 'ToBeCounted.m4M37', dm: '待盘点' }),
    value: '10',
  },
  {
    label: $i18n.get({ id: 'Counted', dm: '已盘点' }),
    value: '40',
  },
];

// 包材异常库存处理状态
const HISTORY_EXCEPTION_STATUS = [
  {
    label: $i18n.get({ id: 'Pending.four_px', dm: '待处理' }),
    value: '10',
  },
  {
    label: $i18n.get({ id: 'Procosed', dm: '已处理' }),
    value: '20',
  },
];

// 包材盘点状态
const PACKAGE_OPERATE_TYPE = [
  {
    label: $i18n.get({ id: 'CheckIn.four_px', dm: '入库' }),
    value: 'IN',
  },

  {
    label: $i18n.get({ id: 'Collar', dm: '领用' }),
    value: 'USE',
  },

  {
    label: $i18n.get({ id: 'Count.four_px', dm: '盘点' }),
    value: 'TAKESTOCK',
  },

  {
    label: $i18n.get({ id: 'Transferin', dm: '调入' }),
    value: 'TRANSFER_IN',
  },

  {
    label: $i18n.get({ id: 'CallOut', dm: '调出' }),
    value: 'TRANSFER_OUT',
  },

  {
    label: $i18n.get({ id: '31255239617286144.CNTM', dm: '退供' }),
    value: 'RETURN',
  },

  {
    label: $i18n.get({ id: 'DB.Packaging.four_px', dm: '打包' }),
    value: 'PACK',
  },

  {
    label: $i18n.get({ id: 'MeasurementUsingWriteoff', dm: '计量（使用核销）' }),
    value: 'METERAGE',
  },
];

// 包装类别
const OUT_PACKAGE_TYPE = [
  {
    label: $i18n.get({ id: 'standPack.four_px', dm: '我司标准包装' }),
    value: 'PACKAGING',
  },

  {
    label: $i18n.get({ id: 'customPack.four_px', dm: '客制物流包装' }),
    value: 'CUSTOM_LOGISTICS',
  },
];

// 出库包装材质
const OUT_PACKAGE_MATERIAL = [
  {
    label: $i18n.get({ id: 'Bag.four_px', dm: '快递袋' }),
    value: 'bag',
  },

  {
    label: $i18n.get({ id: 'PagerBox.four_px', dm: '纸箱' }),
    value: 'box',
  },

  {
    label: $i18n.get({ id: 'Strap.four_px', dm: '缠绕膜' }),
    value: 'strap',
  },

  {
    label: $i18n.get({ id: 'BubbleBag.four_px', dm: '气泡袋' }),
    value: 'bubbleBag',
  },

  {
    label: $i18n.get({ id: 'EnvelopeBag.four_px', dm: '信封袋' }),
    value: 'envelopeBag',
  },

  {
    label: $i18n.get({ id: 'FillingMaterial.four_px', dm: '填充材料' }),
    value: 'fillingMaterial',
  },

  {
    label: $i18n.get({ id: 'Encapsulant.four_px', dm: '封装材料' }),
    value: 'encapsulant',
  },

  {
    label: $i18n.get({ id: 'Label.four_px', dm: '标签纸' }),
    value: 'label',
  },

  {
    label: $i18n.get({ id: 'Pallet.four_px', dm: '托盘' }),
    value: 'pallet',
  },
];

// 包材使用异常处理状态
const PACKAGE_USE_EXCEPTION_STATUS = [
  {
    label: $i18n.get({ id: 'Procosed', dm: '已处理' }),
    value: 'H',
  },

  {
    label: $i18n.get({ id: 'Pending.four_px', dm: '待处理' }),
    value: 'P',
  },
];

// 包材使用异常处理结果
const PACKAGE_USE_EXCEPTION_RESULT = [
  {
    label: $i18n.get({ id: 'errChoosePack.four_px', dm: '打包误选包材' }),
    value: 'EP',
  },

  {
    label: $i18n.get({ id: 'rightChoosePack.four_px', dm: '打包为实际包材' }),
    value: 'AP',
  },
];

// 是否自带物流包装
const LOGISTICS_PACKAGE = [
  {
    label: $i18n.get({ id: 'Yes', dm: '是' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'no', dm: '否' }),
    value: 'N',
  },
];

// 任务类型
const TASK_TYPE = [
  {
    label: 'SO',
    value: 'SO',
  },

  {
    label: 'MOS',
    value: 'MOS',
  },

  {
    label: 'MOD',
    value: 'MOD',
  },

  {
    label: 'MOSS',
    value: 'MOSS',
  },

  {
    label: 'MODS',
    value: 'MODS',
  },

  {
    label: 'MOD-AGG',
    value: 'MOD-AGG',
  },
];

// 面单类型
const AGENT_TYPE = [
  {
    label: $i18n.get({ id: 'ServiceProvider.four_px', dm: '服务商面单' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: 'Invoice.four_px', dm: '发票' }),
    value: '2',
  },

  {
    label: $i18n.get({ id: 'FbaBox.four_px', dm: 'FBA箱唛' }),
    value: '3',
  },

  {
    label: $i18n.get({ id: 'FbaLabel.four_px', dm: 'FBA标签' }),
    value: '4',
  },

  {
    label: $i18n.get({ id: 'FbaOverweightLabel.four_px', dm: 'fba超重标签' }),
    value: '5',
  },

  {
    label: $i18n.get({ id: 'CustomTags.four_px', dm: '自定义标签' }),
    value: '6',
  },

  {
    label: 'vcfbaCartonLabel',
    value: '7',
  },

  {
    label: 'vcfbaAsnLabel',
    value: '8',
  },

  {
    label: 'vcfbaBolLabel',
    value: '9',
  },

  {
    label: $i18n.get({ id: 'ShippingList.four_px', dm: '发货清单' }),
    value: '10',
  },

  {
    label: $i18n.get({ id: 'PackageLabel', dm: '包裹标签' }),
    value: '11',
  },
  {
    label: $i18n.get({ id: 'PackingList', dm: '装箱清单' }),
    value: '12',
  },
  {
    label: $i18n.get({ id: 'ReturnRMAWaybill', dm: '退件RMA面单' }),
    value: '13',
  },
  {
    label: $i18n.get({ id: 'ReturnProductLabel', dm: '退件商品标签' }),
    value: '14',
  },
  {
    label: $i18n.get({ id: 'UnpackingForLabel', dm: '拆箱换标标签' }),
    value: '15',
  },
];

// 打印旋转

const AGENT_ROTATEFLIP = [
  {
    label: $i18n.get({ id: 'NoRotation.four_px', dm: '不旋转' }),
    value: '0',
  },

  {
    label: $i18n.get({ id: 'Rotate90DegreesClockwise.four_px', dm: '顺时针旋转90度' }),
    value: '1',
  },
];

// 打印模式
const AGENT_PRINTMODE = [
  {
    // label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    label: '-',
    value: '',
  },

  {
    label: $i18n.get({ id: 'RepresentativeTemplatePrinting.four_px', dm: '代表模版打印' }),
    value: '0',
  },

  {
    label: $i18n.get({ id: 'PdfPrinting.four_px', dm: 'PDF打印' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: 'ImagePrinting.four_px', dm: '图片打印' }),
    value: '2',
  },

  {
    label: $i18n.get({ id: 'PrintZplFiles.four_px', dm: '代表ZPL文件打印' }),
    value: '3',
  },
];

// 尺寸适用范围
const AGENT_PRINT_USERANGE = [
  {
    label: $i18n.get({ id: 'PCPackingReturningRetyping', dm: 'PC（打包、退件、补打）' }),
    value: 'PC',
    disabled: true,
    // defaultChecked: true,
  },

  {
    label: $i18n.get({ id: 'PDABluetoothPickQuickPick', dm: 'PDA（蓝牙拣选、快拣）' }),
    value: 'PDA',
  },
];

// 打印渲染

const AGENT_PRINTSWITCH = [
  {
    label: $i18n.get({ id: 'Is.four_px', dm: '是' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: 'F.No.four_px', dm: '否' }),
    value: '2',
  },
];

// 状态

const AGENT_STATE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'Enable.four_px', dm: '启用' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'JY.Disable.four_px', dm: '禁用' }),
    value: 'N',
  },
];

// 文章类型
const ATRICLE_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'FaqAndHelp.four_px', dm: '常见问题与帮助' }),
    value: 'QUESTION_AND_HELP',
  },

  {
    label: $i18n.get({ id: 'MessageReminder.four_px', dm: '消息提醒' }),
    value: 'MESSAGE_REMINDER',
  },
];

// 多包裹重新换号
const MUL_PACKAGE_CHANGE_NO = [
  {
    label: $i18n.get({ id: 'EnableAndVerifySku.four_px', dm: '启用并校验SKU' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'EnableNonVerificationSku.four_px', dm: '启用不校验SKU' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'JY.Disable.four_px', dm: '禁用' }),
    value: 'N',
  },
];

// 多包裹打包校验类型
const MUL_PACKAGE_VERIFICATION_TYPE = [
  {
    label: $i18n.get({ id: 'WeighingOnly.four_px', dm: '只称重' }),
    value: '10',
  },

  {
    label: $i18n.get({ id: 'WeighingAndWeighingVolume.four_px', dm: '称重又量体积' }),
    value: '11',
  },

  {
    label: $i18n.get({ id: 'EnterOnlyTheNumberOfPackages.four_px', dm: '只录入包裹数量' }),
    value: '20',
  },
];

/**
 * 钉钉推送
 */
// 推送语言
const DD_LAN_TYPE = [
  {
    label: $i18n.get({ id: 'Chinese.four_px', dm: '中文' }),
    value: 'zh',
  },

  {
    label: $i18n.get({ id: 'English.four_px', dm: '英文' }),
    value: 'en',
  },

  {
    label: $i18n.get({ id: 'Japanese.four_px', dm: '日文' }),
    value: 'jp',
  },

  {
    label: $i18n.get({ id: 'Italian.four_px', dm: '意大利文' }),
    value: 'italy',
  },

  {
    label: $i18n.get({ id: 'Russian.four_px', dm: '俄罗斯文' }),
    value: 'russian',
  },

  {
    label: $i18n.get({ id: 'Spanish.four_px', dm: '西班牙语' }),
    value: 'spain',
  },
];

// 推送时间
const DD_PUSH_TIME_TYPE = [
  {
    label: '00:00',
    value: '00:00',
  },

  {
    label: '01:00',
    value: '01:00',
  },

  {
    label: '02:00',
    value: '02:00',
  },

  {
    label: '03:00',
    value: '03:00',
  },

  {
    label: '04:00',
    value: '04:00',
  },

  {
    label: '05:00',
    value: '05:00',
  },

  {
    label: '06:00',
    value: '06:00',
  },

  {
    label: '07:00',
    value: '07:00',
  },

  {
    label: '08:00',
    value: '08:00',
  },

  {
    label: '09:00',
    value: '09:00',
  },

  {
    label: '10:00',
    value: '10:00',
  },

  {
    label: '11:00',
    value: '11:00',
  },

  {
    label: '12:00',
    value: '12:00',
  },

  {
    label: '13:00',
    value: '13:00',
  },

  {
    label: '14:00',
    value: '14:00',
  },

  {
    label: '15:00',
    value: '15:00',
  },

  {
    label: '16:00',
    value: '16:00',
  },

  {
    label: '17:00',
    value: '17:00',
  },

  {
    label: '18:00',
    value: '18:00',
  },

  {
    label: '19:00',
    value: '19:00',
  },

  {
    label: '20:00',
    value: '20:00',
  },

  {
    label: '21:00',
    value: '21:00',
  },

  {
    label: '22:00',
    value: '22:00',
  },

  {
    label: '23:00',
    value: '23:00',
  },
];

// 星期
const WEEK_ENUM = [
  {
    label: $i18n.get({ id: 'Monday.four_px', dm: '星期一' }),
    value: 'MONDAY',
  },

  {
    label: $i18n.get({ id: 'Tuesday.four_px', dm: '星期二' }),
    value: 'TUESDAY',
  },

  {
    label: $i18n.get({ id: 'Wednesday.four_px', dm: '星期三' }),
    value: 'WEDNESDAY',
  },

  {
    label: $i18n.get({ id: 'Thursday.four_px', dm: '星期四' }),
    value: 'THURSDAY',
  },

  {
    label: $i18n.get({ id: 'XQW.Friday.four_px', dm: '星期五' }),
    value: 'FRIDAY',
  },

  {
    label: $i18n.get({ id: 'XQL.Saturday.four_px', dm: '星期六' }),
    value: 'SATURDAY',
  },

  {
    label: $i18n.get({ id: 'XQR.Sunday.four_px', dm: '星期日' }),
    value: 'SUNDAY',
  },
];

// 产品类型
const DD_PRODUCT_TYPE = [
  {
    label: 'ALL',
    value: 'ALL',
  },

  {
    label: '2B',
    value: '2B',
  },

  {
    label: '2C',
    value: '2C',
  },
];

// 库内配置客户类型vip:VIP库区,baocang:包仓库区
const CUSTOMER_TYPE_LOCATION = [
  {
    label: $i18n.get({ id: 'VIPReservoirArea', dm: 'VIP库区' }),
    value: 'vip',
  },

  {
    label: $i18n.get({ id: 'PackageWarehouseArea', dm: '包仓库区' }),
    value: 'baocang',
  },
];

const PICKING_TYPE = [
  {
    label: $i18n.get({ id: 'menu_picking_special', dm: '快拣' }),
    value: '10',
  },

  {
    label: $i18n.get({ id: 'StandardOutbound.four_px', dm: '标准出库' }),
    value: '20',
  },
];

const CHANNEL_GROUP_PICKING_TYPE = [
  {
    label: $i18n.get({ id: 'menu_picking_special', dm: '快拣' }),
    value: '10',
  },
];

const REMITTANCE_TYPE = [
  {
    label: $i18n.get({ id: 'HandmadeHuibo.four_px', dm: '手工汇波' }),
    value: '10',
  },

  {
    label: $i18n.get({ id: 'AutomaticHuibo.four_px', dm: '自动汇波' }),
    value: '20',
  },
];

// 打印类型
// 操作台、分拣墙、分拣墙格口标签
const OPA_PRINT_LABEL = 'OPERATE_PLATFORM_LABEL';

// 拣货框标签
const BASKET_PRINT_LABEL = 'CONTAINER_BASKET_LABEL';

// 托盘标签
const PALLET_PRINT_LABEL = 'CONTAINER_PALLET_LABEL';

// 基础服务器地址
const BASEDATASERVICE = 'giws-basic';

const PWD_TYPE_DATA = [
  {
    label: $i18n.get({ id: '31255241978679296.CNTM', dm: '拣选' }),
    value: '00',
  },
  {
    label: $i18n.get({ id: 'PickAndDivide.four_px', dm: '边拣边分' }),
    value: '10',
  },
  {
    label: $i18n.get({ id: 'BluetoothPrintPicking.four_px', dm: '蓝牙打印拣选' }),
    value: '20',
  },
  {
    label: $i18n.get({ id: 'QuickPick.four_px', dm: '快拣' }),
    value: '30',
  },
  {
    label: $i18n.get({ id: '31255238946197504.CNTM', dm: '分拣' }),
    value: '40',
  },
  {
    label: $i18n.get({ id: 'PickDoublePicking', dm: '拣选（复拣）' }),
    value: '01',
  },
  {
    label: $i18n.get({ id: 'SortingDoublePicking', dm: '分拣（复拣）' }),
    value: '41',
  },
  {
    label: $i18n.get({ id: 'PackedWithLessGoods.four_px', dm: '打包少货' }),
    value: '50',
  },
  {
    label: $i18n.get({ id: 'PackageReremittance', dm: '打包重新汇单' }),
    value: '60',
  },
  {
    label: $i18n.get({ id: 'PackageOutOfStockSubmission', dm: '打包缺货提交' }),
    value: '70',
  },
  {
    label: $i18n.get({ id: 'ServiceProviderReturnsPartsToShe_1565814076', dm: '服务商退件上架' }),
    value: '80',
  },
  {
    label: $i18n.get({ id: 'EmergencyReplenishmentOfOrders', dm: '接单紧急补货' }),
    value: '90',
  },
  {
    label: $i18n.get({ id: 'YKSJ.StorageAndShelving.four_px', dm: '移库上架' }),
    value: '100',
  },
  {
    label: $i18n.get({ id: 'RemittanceEmergency', dm: '汇单紧急' }),
    value: '91',
  },
  {
    label: $i18n.get({ id: 'InventoryEmergencyReplenishment', dm: '库存紧急' }),
    value: '92',
  },
  {
    label: $i18n.get({ id: 'TransferToStorage.four_px', dm: '转存移库' }),
    value: '93',
  },
  {
    label: $i18n.get({ id: 'AbcDatabaseMigration.four_px', dm: 'ABC移库' }),
    value: '94',
  },
  {
    label: $i18n.get({ id: 'DailyReplenishment.four_px', dm: '日常补货' }),
    value: '95',
  },
];
const APPLY_SCOPE = [
  {
    label: $i18n.get({ id: 'GeneralRules', dm: '通用规则' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: 'DesignatedCustomer', dm: '指定客户' }),
    value: '2',
  },
];
const ABC_STATUS = [
  {
    label: $i18n.get({ id: 'Enable.four_px', dm: '启用' }),
    value: 1,
  },
  {
    label: $i18n.get({ id: 'TY.Disable.four_px', dm: '停用' }),
    value: 0,
  },
];

const DOUCMENT_TYPE = [
  {
    label: $i18n.get({ id: 'CKDD.OutboundOrder.four_px', dm: '出库订单' }),
    value: 'OUTBOUND',
  },
  {
    label: $i18n.get({ id: 'InboundOrder.four_px', dm: '入库订单' }),
    value: 'INBOUND',
  },
];
export {
  WORK_TYPE,
  CONTAINER_TYPE,
  WORK_STATUS,
  ENABLE_STATUS,
  TYPE,
  NO_IN_TYPE,
  ASSORT_STATUS,
  OPERATE_FLOOR_TYPE,
  AREA_TYPE,
  SUBMIT_STATUS,
  PACKING_TYPE,
  PACKAGE_TYPE2,
  BUSINESS_TYPE,
  BUSINESS_TYPE2,
  PACKAGE_OPERATE_TYPE,
  OUT_PACKAGE_TYPE,
  OUT_PACKAGE_MATERIAL,
  PACKAGE_USE_EXCEPTION_STATUS,
  PACKAGE_USE_EXCEPTION_RESULT,
  LOGISTICS_PACKAGE,
  TASK_TYPE,
  PACKING_TEXTURE,
  PACKING_PRICE,
  OPA_PRINT_LABEL,
  BASKET_PRINT_LABEL,
  PALLET_PRINT_LABEL,
  BASEDATASERVICE,
  AGENT_TYPE,
  AGENT_PRINT_USERANGE,
  AGENT_ROTATEFLIP,
  AGENT_PRINTMODE,
  AGENT_PRINTSWITCH,
  AGENT_STATE,
  ATRICLE_TYPE,
  MUL_PACKAGE_CHANGE_NO,
  MUL_PACKAGE_VERIFICATION_TYPE,
  DD_LAN_TYPE,
  DD_PUSH_TIME_TYPE,
  DD_PRODUCT_TYPE,
  CUSTOMER_TYPE_LOCATION,
  WEEK_ENUM,
  PICKING_TYPE,
  REMITTANCE_TYPE,
  PWD_TYPE_DATA,
  DESTORY_TYPE,
  CustomerCodeOrCustomerId,
  PACKAGE_TAKESTOCK_STATUS,
  HISTORY_EXCEPTION_STATUS,
  CHANNEL_GROUP_PICKING_TYPE,
  CUSTOME_GROUP_RELATION,
  APPLY_SCOPE,
  ABC_STATUS,
  DOUCMENT_TYPE,
};
